/*
 * @Author: zxf
 * @Date: 2021-10-20 14:14:38
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-15 14:22:16
 * @Description: file content
 * @FilePath: \neolix-map-sdk\src\tool\Tool.js
 */
import * as THREE from "../../libs/three.js/build/three.module.js";
import {CSS2DObject} from "../../libs/three.js/renderers/CSS2DRenderer.js";
import {SceneRegister} from "../register/SceneRegister.js";
import {GemmetryAlgorithm} from "../algorithm/geometry.js";
import {Snap} from "../snap/SnapBase.js";
import {TextSprite} from "../TextSprite.js";
import Base from '../clazz/Base';
import {Utils} from "../utils.js";
import { SnapController } from "./../snap/SnapController.js";
import { SnapFeature, SnapPointCloud } from "./../snap/index";
import { RenderController } from "../render/RenderController.js";
import { Operation } from "../operation/index.js";

export class Tool extends Base {
	constructor (options) {
		super();
		this.isActive = false;
		this.sceneRegister = SceneRegister.getInstance();
		this.gemmetryAlgorithm = GemmetryAlgorithm.getInstance();
		this.snapController = SnapController.getInstance();
		this.snapCtrl = Snap.getInstance();
		this.renderController = RenderController.getInstance();
		this.mouseInfoSymbol = null;
		this.feedbackScene = this.sceneRegister.scenes.feedback;
		this.feedback = new THREE.Object3D();
		this.mouseInfoFeedback = new THREE.Object3D();
		this.mouse = null;
		this.logMessages = false;
		this.snapActorsConfig = [];
		this.operation = Operation.getInstance();
	}

	onActive(options) {
        if (this.isActive) {
            return false;
        }

        this.isActive = true;
        this.viewer = options.viewer;
		this.renderer = options.viewer.renderer;
		this.domElement = this.viewer.renderArea;
		this.scene = options.viewer.scene;
		this.topoEditor = options.topoEditor ? options.topoEditor : null;
		this.mode = options.mode;
        super.setOptions(options);
        this.cursor = this.domElement.style.cursor;
        this.domElement.style.cursor = 'default';

        return true;
    }

	onDeactive() {
        if (!this.isActive) {
            return true;
        }

		this.viewer.inputHandler.setHandlerEnabled(true);
		this.viewer = null;
		this.renderer = null;
		this.domElement = null;
		this.scene = null;
		this.topoEditor = null;
		this.mode = null;
		this.isActive = false;
		this.initFeadback();
        return true;
    }

	setSnapActors() {
		this.snapController.clear();
		if(this.topoEditor) {
			switch(this.mode) {
				case 'create':
					this.snapActorsConfig = this.topoEditor.getCreateSnapActors();
					break;
				case 'modify':
					this.snapActorsConfig = this.topoEditor.getModifySnapActors();
					break;
				case 'break':
					this.snapActorsConfig = this.topoEditor.getBreakSnapActors();
					break;
				case 'relation':
				this.snapActorsConfig = this.topoEditor[`getRelation${this.relationType}SnapActors`]();
					break;
				case 'merge':
					this.snapActorsConfig = this.topoEditor.getMergeSnapActors();
					break;
				case 'copyModify':
				this.snapActorsConfig = this.topoEditor.getCopyModifySnapActors();
				break;
				default:
					break;
			}
		}
		for(let i = 0; i < this.snapActorsConfig.length; i++) {
			const item = this.snapActorsConfig[i];
			const snapActor = new SnapFeature({ ...item, viewer: this.viewer });
			this.snapController.add(snapActor);
		}
		if(this.mode != 'relation') {
			const pointCloudSnap = new SnapPointCloud({ priority: 0, enable: true, viewer: this.viewer });
			this.snapController.add(pointCloudSnap);
		}
	}

	createSnapActor(options) {
		const snapActor = new SnapFeature({ ...options, viewer: this.viewer });
		this.snapController.add(snapActor);
	}

	start() {
		this.setSnapActors();
		this.initFeadback();
		this.viewer.inputHandler.setHandlerEnabled(false);
		this.createMouseLabel();
		this.snapController.startup();
		this.domElement.focus();
	}

	initFeadback() {
		this.feedback.clear();
		this.mouseInfoFeedback.clear();
		this.feedbackScene.add(this.feedback);
		this.mouseInfoFeedback.name = 'mouseInfoFeedback';
		this.feedbackScene.add(this.mouseInfoFeedback);
		this.operation.clear();
	}

	setMouseInfo(text) {
		this.mouseInfoSymbol.setText(text);
	}

	setMouseLableGeo() {
		const camera = this.scene.getActiveCamera();
        this.mouseInfoSymbol.position.copy(this.mouse);
		let distance = camera.position.distanceTo(this.mouseInfoSymbol.getWorldPosition(new THREE.Vector3()));
		let pr = Potree.Utils.projectedRadius(1, camera, distance, this.domElement.clientWidth, this.domElement.clientHeight);
		let scale = (70 / pr);
		if (Potree.debug.scale) {
			scale = (Potree.debug.scale / pr);
		}
		this.mouseInfoSymbol.scale.set(scale, scale, scale);
		this.renderController.setStatus(true);
    }

	createMouseLabel() {
		const mouseLabel = document.createElement( 'div' );
		mouseLabel.className = 'label label-mouse';
		mouseLabel.textContent = '';
		mouseLabel.contentEditable = false;
		const textLabel = new CSS2DObject( mouseLabel );
		this.mouseInfoSymbol = textLabel;
		this.mouseInfoFeedback.add(this.mouseInfoSymbol);
	}

	onKeyDown (e) {
		e.preventDefault();
		if(e.ctrlKey && !e.shiftKey && !e.altKey && e.keyCode === 90) {
			this.operation.pop();
		}
	}

  onRightButtonClick(e) {
    e.preventDefault();
    if(!e.ctrlKey) {
      this.operation.pop();
    }
  }

	onKeyUp (e) {
		e.preventDefault();
	}

	onDoubleClick (e) {
		e.preventDefault();
	}

	onMouseClick (e) {
		e.preventDefault();
	}

	onMouseDown (e) {
	}

	onMouseUp (e) {

	}

	onMouseMove (e) {
		this.mouse = Utils.getWorldCoordinate(this.domElement, this.scene, e.offsetX, e.offsetY + 15, 0);
        this.setMouseLableGeo();
	}
}
